import React from 'react'

import { useMultiSelectState } from './MultiSelectHandler'
import Marker from '../shapes/Marker'
import SelectAllCheckbox from './SelectAllCheckbox'

export const useMultiSelectColumns = (data, onSelectAll, rowKey = 'id') => {
  const { active, selecteds, handleSelect } = useMultiSelectState() || {}

  if (!active) return []

  return [
    {
      flex: 1,
      maxWidth: 2,
      render: record => <Marker value={selecteds.includes(record[rowKey])} onChange={handleSelect(record[rowKey])} />,
      renderHeader: () => <SelectAllCheckbox data={data} onSelectAll={onSelectAll} rowKey={rowKey} />
    }
  ]
}
